import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { useCompanyStatsStore } from '@/store/companyStats'
import SignUpView from '../views/SignUpView.vue';
import { useUserStore } from '@/store/userData';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/admin/tracker',
  //   name: 'Admin Tracker | doored',
  //   component: () => import('../views/TrackerAdmin.vue'),
  //   meta: { scrollToTop: true, requiresAuth: true, requiresAdmin: true }
  // },
  {
    path: '/admin/partners',
    name: 'Admin Partner | doored',
    component: () => import('../components/appState/PartnershipAdmin.vue'),
    meta: { scrollToTop: true, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/partner',
    name: 'Admin Partners | doored',
    component: () => import('../views/PartnerAdminView.vue'),
    meta: { scrollToTop: true, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/tests',
    name: 'Admin Tests | doored',
    component: () => import('../components/tests/TestManagementAdmin.vue'),
    meta: { scrollToTop: true, requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/member/partners',
    name: 'Partners | doored',
    component: () => import('../components/appState/PartnershipDashboard.vue'),
    meta: { scrollToTop: true, requiresAuth: true  }
  },
  {
    path: '/signup',
    name: 'Sign up | doored',
    component: SignUpView,
    meta: { scrollToTop: true}
  },
  {
    path: '/oauth-bridge',
    name: 'oauth-bridge',
    component: () => import('../views/OauthBridge.vue'),
  },
  {
    path: '/login',
    name: 'Login | doored',
    component: () => import('../views/LoginView.vue'),
    meta: { scrollToTop: true}
  },
  {
    path: '/update-password',
    name: 'Update password | doored',
    component: () => import('../views/UpdatePasswordView.vue'),
    meta: { scrollToTop: true}
  },  
  {
    path: '/',
    name: 'Practice | doored',
    component: () => import('../views/LoggedinView.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },
  {
    path: '/forum',
    name: 'Forum | doored',
    component: () => import('../views/ForumView.vue'),
    meta: { scrollToTop: true, requiresAuth: true}
  },
  {
    path: '/create-post',
    name: 'Create post | doored',
    component: () => import('../views/CreatePostView.vue'),
    meta: { scrollToTop: true, requiresAuth: true}
  },
  {
    path: '/forum/:postId/:postSlug',
    name: 'Post | doored',
    component: () => import('../views/PostView.vue'),
    meta: { scrollToTop: true, requiresAuth: true}
  },
  {
    path: '/profile/:username',
    name: 'Profile | doored',
    component: () => import('../views/ProfileView.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  }, 
  {
    path: '/leaderboards',
    name: 'Leaderboards | doored',
    component: () => import('../views/LeaderboardsView.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },
  // {
  //    path: '/tracker',
  //    name: 'Tracker | doored',
  //    component: () => import('../views/TrackerView.vue'),
  //    meta: { scrollToTop: true, requiresAuth: true},
  // },
  {
    path: '/settings',
    name: 'Settings | doored',
    component: () => import('../views/SettingsView.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },
  {
    path: '/company/:id',
    name: 'Company | doored',
    component: () => import('../components/tests/MainCompany.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },
  {
    path: '/test/:id',
    name: 'Test | doored',
    component: () => import('../components/tests/TestPage.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },
  {
    path: '/instructions/:',
    name: 'Test Instructions | doored',
    component: () => import('../components/tests/TestIntructions.vue'),
    meta: { scrollToTop: true, requiresAuth: true},
  },


  //STANDARD TESTS - MED I TESTSHELL
  {
    path: '/gapchallenge/:test_id',
    name: 'GapChallenge | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    meta: { requiresAuth: true},
    props: { component: () => import('../components/tests/Aon/GapChallenge.vue') }
  },
  {
    path: '/chatassess/:test_id',
    name: 'ChatAssess | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    meta: { requiresAuth: true},
    props: { component: () => import('../components/tests/SJTs/ChatAssesTest.vue') }
  },
  {
    path: '/iqtest/:test_id',
    name: 'Matrices | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Multi/IqTest.vue') }
  }, 
  {
    path: '/cutescales/:test_id',
    name: 'Cut-E | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Cut-E/CutEScales.vue') }
  },
  {
    path: '/pipetest/:test_id',
    name: 'SwitchChallenge | doored',
    component: () => import('../components/tests/Aon/PipeTest.vue'),
  },
  {
    path: '/pipetest/results/:test_id',
    name: 'SwitchChallenge Results | doored',
    component: () => import('../components/tests/Aon/PipeTestResults.vue'),
  },
  {
    path: '/clxtest/:test_id',
    name: 'CLX | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Cut-E/CLXTest.vue') }
  },
  {
    path: '/verbalability/:test_id',
    name: 'Verbal Ability | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Multi/VerbalAbilityTest.vue') }
  },
  {
    path: '/numericalabilitytest/:test_id',
    name: 'Numerical Ability | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Multi/NumericalAbilityTest.vue') }
  },
  {
    path: '/motion/:test_id',
    name: 'Motionchallenge | doored',
    component: () => import('../components/tests/Cut-E/MotionChallenge.vue'),
  },
  {
    path: '/motionchallenge/results/:test_id',
    name: 'Motion Results | doored',
    component: () => import('../components/tests/Cut-E/MotionChallengeResults.vue'),
  },
  {
    path: '/scalesixtest/:test_id',
    name: 'Scales IX | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Aon/ScalesIx.vue') }
  },
  {
    path: '/elementsnumerical/:test_id',
    name: 'Elements Numerical | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Talent-Q/ElementsNumerical.vue') }
  },
  {
    path: '/elementslogical/:test_id',
    name: 'Elements Logical | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Talent-Q/ElementsLogical.vue') }
  },
  {
    path: '/elementsverbal/:test_id',
    name: 'Elements Verbal | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Talent-Q/ElementsVerbal.vue') }
  },
  {
    path: '/datamonitor/:test_id',
    name: 'Data Monitor | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/HSBC/DataMonitor.vue') }
  },
  {
    path: '/conflictingcommitments/:test_id',
    name: 'Competing Commitments | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/HSBC/ConflictingCommitments.vue') }
  },
  {
    path: '/sjthsbc/:test_id',
    name: 'SJT HSCB | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/SJTHsbc.vue') }
  },
  {
    path: '/shlringpuzzle/:test_id',
    name: 'SHL Ringpuzzle | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLRingPuzzle.vue') }
  },
  {
    path: '/shlcolorzone/:test_id',
    name: 'SHL Colorzone | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLColorZone.vue') }
  },
  {
    path: '/shlgeneralability/:test_id',
    name: 'SHL G+ | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLGeneralAbility.vue') }
  },
  {
    path: '/opq32/:test_id',
    name: 'OPQ32+ | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/OPQ32.vue') }
  },
  {
    path: '/shlpattern/:test_id',
    name: 'SHL Pattern | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLPattern.vue') }
  },
  {
    path: '/shlseries/:test_id',
    name: 'SHL Series | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLSeries.vue') }
  },
  {
    path: '/shloddoneout/:test_id',
    name: 'SHL Oddoneout | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLOddOneOut.vue') }
  },
  {
    path: '/shlverify/:test_id',
    name: 'SHL Verify | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLVerfiy.vue') }
  },
  {
    path: '/shlverbal/:test_id',
    name: 'SHL Verbal | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLVerbal.vue') }
  },
  {
    path: '/shlnumerical/:test_id',
    name: 'Numerical Test | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLNumerical.vue') }
  },
  {
    path: '/barclayscognitive/:test_id',
    name: 'Barclays Assesssment | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Barclays/BarclaysCognitive.vue') }
  },
  {
    path: '/danskesjt/:test_id',
    name: 'SJT Assessment | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/DanskeSJT.vue') }
  },
  {
    path: '/danskesjtgrad/:test_id',
    name: ' SJT Grad | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/DanskeSJTGrad.vue') }
  },
  {
    path: '/ubssjt/:test_id',
    name: 'SJT UBS | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/UbsSjt.vue') }
  },
  {
    path: '/scalessx/:test_id',
    name: 'Scales SX | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Aon/ScalexSX.vue') }
  },
  {
    path: '/shlgeneralnumerical/:test_id',
    name: 'SHL G+ Numerical | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SHL/SHLGeneralNumerical.vue') }
  },
  {
    path: '/suitedcheckingaccuracy/:test_id',
    name: 'SUITED Accuracy| doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SUITED/SuitedAccuracy.vue') }
  },
  {
    path: '/suitedlogical/:test_id',
    name: 'SUITED Logical | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SUITED/SuitedLogical.vue') }
  },
  {
    path: '/suitednumberseries/:test_id',
    name: 'SUITED Numbers | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SUITED/SuitedNumberSeries.vue') }
  },
  {
    path: '/rothschildsjt/:test_id',
    name: 'SJT Test | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/RothschildSJT.vue') }
  },
  {
    path: '/aboutyou/:test_id',
    name: 'AbouYou | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SJTs/AboutYou.vue') }
  },
  {
    path: '/cappcritical/:test_id',
    name: 'CappFinity Critical | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Deloitte/CappCritical.vue') }
  },
  {
    path: '/ccatlazard/:test_id',
    name: 'CCAT | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/CCAT/CCATLazard.vue') }
  },
  {
    path: '/lazardlogic/:test_id',
    name: 'Lazard Logic Assessment | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/CCAT/LazardLogical.vue') }
  },
  {
    path: '/lazardspatial/:test_id',
    name: 'Lazard Spatial Assessment | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/CCAT/LazardSpatial.vue') }
  },
  {
    path: '/truefalse/:test_id',
    name: 'T/F/C Test | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/SOVA/TrueOrFalse.vue') }
  },
  {
    path: '/memorytest/:test_id',
    name: 'Memory Test | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/CreditAgricolé/MemoryTest.vue') }
  },
  {
    path: '/sentenceoddoneout/:test_id',
    name: 'Oddoneout Test | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/CreditAgricolé/WordOddOneOut.vue') }
  },
  {
    path: '/deloitte-sim/:test_id',
    name: 'Deloitte Job Sim | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Deloitte/DeloitteSim.vue') }
  },
  {
    path: '/cappnumerical/:test_id',
    name: 'CappFinity | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Cappfinity/CappNumerical.vue') }
  },
  {
    path: '/eysim/:test_id',
    name: 'Job Sim | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Big4/EySim.vue') }
  },
  {
    path: '/kpmgsim/:test_id',
    name: 'KPMG Job Sim | doored',
    component: () => import('../components/tests/NormalTestShell.vue'),
    props: { component: () => import('../components/tests/Big4/KPMGSim.vue') }
  },
  
 //NON-Standard = Helt egen component
{
  path: '/personalityscales/:test_id',
  name: 'Personality Scales | dooored',
  component: () => import('../components/tests/NormalTestShell.vue'),
  props: { component: () => import('../components/tests/SJTs/PersonalityScales.vue') }
},
{
  path: '/personalityscales/results',
  name: 'Personalitytest Results | doored',
  component: () => import('../components/tests/SJTs/PersonalityScalesResult.vue'),
},
{
  path: '/aonadept15/results',
  name: 'AON Adept Results| doored',
  component: () => import('../components/tests/Aon/AonResults.vue')
},
{
  path: '/aonadept15/:test_id',
  name: 'AON Adept | doored',
  component: () => import('../components/tests/NormalTestShell.vue'),
  props: { component: () => import('../components/tests/Aon/AonADEPT15.vue') }
},
{
  path: '/plymetricsdigits/:test_id',
  name: 'Pymetrics Digits | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsDigits.vue'),
},
{
  path: '/plymetricstower/:test_id',
  name: 'Pymetrics Tower | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsTowers.vue'),
},
{
  path: '/plymetricskeypresses/:test_id',
  name: 'Pymetrics Keypresses | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsKeypresses.vue'),
},
{
  path: '/plymetricsstopgame/:test_id',
  name: 'Pymetrics Stopgame | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsStopgame.vue'),
},
{
  path: '/plymetricsarrows/:test_id',
  name: 'Pymetrics Arrows | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsArrows.vue'),
},
{
  path: '/plymetricslenghts/:test_id',
  name: 'PymetricsLenghts | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsLenghts.vue'),
},
{
  path: '/plymetricsmoney1/:test_id',
  name: 'Pymetrics Money 1 | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsMoney1.vue'),
},
{
  path: '/plymetricsmoney2/:test_id',
  name: 'Pymetrics Money 2 | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsMoney2.vue'),
},
{
  path: '/plymetricsfaces/:test_id',
  name: 'PymetricsFaces | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsFaces.vue'),
},
{
  path: '/plymetricscards/:test_id',
  name: 'PymetricsCards | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsCards.vue'),
},
{
  path: '/plymetricseasyhard/:test_id',
  name: 'PymetricsEasyHard | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsEasyHard.vue'),
},
{
  path: '/plymetricsbaloon/:test_id',
  name: 'PymetricsBaloons | doored',
  component: () => import('../components/tests/Pymetrics/PlymetricsBaloon.vue'),
},
{
  path: '/gridchallenge/:test_id',
  name: 'Gridchallenge | doored',
  component: () => import('../components/tests/RBC/CognitiveTest.vue'),
},
{
  path: '/cognitive-test/results/:sessionId',
  name: 'Gridchallenge | Results',
  component: () => import('../components/tests/RBC/CognitiveTestResults.vue'),
},
{
  path: '/digitschallenge/:test_id',
  name: 'Digitschallenge | doored',
  component: () => import('../components/tests/RBC/NumericTestIndex.vue'),
},
{
  path: '/numeric-test/interface',
  name: 'Digitschallenge Test | doored',
  component: () => import('../components/tests/RBC/NumericTestInterface.vue'),
},
{
  path: '/numeric-test/results',
  name: 'Digitschallenge | Results',
  component: () => import('../components/tests/RBC/NumericTestResults.vue'),
},
{
  path: '/mckinsey-ecosystem/:test_id',
  name: 'Ecosystem | McKinsey',
  component: () => import('../components/tests/McKinseySim/McKinseyEcosystem.vue'),
},
{
    path: '/test/mckinsey-ecosystem/:test_id/results/:result_id',
    name: 'Ecosystem | Results',
    component: () => import('@/components/tests/McKinseySim/McKinseyEcosystemResults.vue'),
},
{
  path: '/mckinsey-redrock/:test_id',
  name: 'Redrock | McKinsey',
  component: () => import('../components/tests/McKinseySim/McKinseyRedrock.vue'),
},
{
    path: '/test/mckinsey-redrock/:test_id/results/:result_id',
    name: 'Redrock | Results',
    component: () => import('@/components/tests/McKinseySim/McKinseyRedrockResults.vue'),
},
{
  path: '/mckinsey-seawolf/:test_id',
  name: 'Seawolf | McKinsey',
  component: () => import('../components/tests/McKinseySim/McKinseySeawolf.vue'),
},
{
    path: '/test/mckinsey-seawolf/:test_id/results/:result_id',
    name: 'Seawolf | Results',
    component: () => import('@/components/tests/McKinseySim/McKinseySeawolfResults.vue'),
},

//RESULTS VIEWS
{
    path: '/results',
    name: 'Results | doored',
    component: () => import('../components/results/TestResults.vue'),
    props: route => ({
      testId: route.query.test_id,
      username: route.query.username,
      resultId: route.query.result_id
    })
  },
  {
    path: '/review/elementsnumerical/:test_id/:question_id/:question_index',
    name: 'Elementsnumerical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Talent-Q/ElementsNumerical.vue')
    }
  },
  {
    path: '/review/elementslogical/:test_id/:question_id/:question_index',
    name: 'Elementslogical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Talent-Q/ElementsLogical.vue')
    }
  },
  {
    path: '/review/elementsverbal/:test_id/:question_id/:question_index',
    name: 'Elementsverbal | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Talent-Q/ElementsVerbal.vue')
    }
  },
  {
    path: '/review/suitedaccuracy/:test_id/:question_id/:question_index',
    name: 'Suitedcheckingaccuracy | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SUITED/SuitedAccuracy.vue')
    }
  },
  {
    path: '/review/suitedlogical/:test_id/:question_id/:question_index',
    name: 'Suitedlogical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SUITED/SuitedLogical.vue')
    }
  },
  {
    path: '/review/suitednumberseries/:test_id/:question_id/:question_index',
    name: 'Suitednumberseries | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SUITED/SuitedNumberSeries.vue')
    }
  },
  {
    path: '/review/trueorfalse/:test_id/:question_id/:question_index',
    name: 'Truefalse | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SOVA/TrueOrFalse.vue')
    }
  },
  {
    path: '/review/aboutyou/:test_id/:question_id/:question_index',
    name: 'Aboutyou | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/AboutYou.vue')
    }
  },
  {
    path: '/review/chatasses/:test_id/:question_id/:question_index',
    name: 'Chatasses | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/ChatAssesTest.vue')
    }
  },
  {
    path: '/review/danskesjt/:test_id/:question_id/:question_index',
    name: 'Danskesjt | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/DanskeSJT.vue')
    }
  },
  {
    path: '/review/danskesjtgrad/:test_id/:question_id/:question_index',
    name: 'Danskesjtgrad | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/DanskeSJTGrad.vue')
    }
  },
  {
    path: '/review/opq-32/:test_id/:question_id/:question_index',
    name: 'Opq-32 | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/OPQ32.vue')
    }
  },
  {
    path: '/review/rothschildsjt/:test_id/:question_id/:question_index',
    name: 'Rothschildsjt | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/RothschildSJT.vue')
    }
  },
  {
    path: '/review/rothschildsjt/:test_id/:question_id/:question_index',
    name: 'Sjthsbc | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/SJTHsbc.vue')
    }
  },
  {
    path: '/review/ubssjt/:test_id/:question_id/:question_index',
    name: 'Ubssjt | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SJTs/UbsSjt.vue')
    }
  },
  {
    path: '/review/shlverify/:test_id/:question_id/:question_index',
    name: 'Shlverify | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLVerfiy.vue')
    }
  },
  {
    path: '/review/shlverbal/:test_id/:question_id/:question_index',
    name: 'Shlverbal | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLVerbal.vue')
    }
  },
  {
    path: '/review/shlseries/:test_id/:question_id/:question_index',
    name: 'Shlseries | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLSeries.vue')
    }
  },
  {
    path: '/review/shlpattern/:test_id/:question_id/:question_index',
    name: 'Shlpattern | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLPattern.vue')
    }
  },
  {
    path: '/review/shloddoneout/:test_id/:question_id/:question_index',
    name: 'Shloddoneout | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLOddOneOut.vue')
    }
  },
  {
    path: '/review/shlnumerical/:test_id/:question_id/:question_index',
    name: 'Shlnumerical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLNumerical.vue')
    }
  },
  {
    path: '/review/iqtest/:test_id/:question_id/:question_index',
    name: 'Iqtest | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Multi/IqTest.vue')
    }
  },
  {
    path: '/review/numericalability/:test_id/:question_id/:question_index',
    name: 'Numericalability | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Multi/NumericalAbilityTest.vue')
    }
  },
  {
    path: '/review/verbalability/:test_id/:question_id/:question_index',
    name: 'Verbalability | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Multi/VerbalAbilityTest.vue')
    }
  },
  {
    path: '/review/conflictingcommitments/:test_id/:question_id/:question_index',
    name: 'Conflictingcommitments | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/HSBC/ConflictingCommitments.vue')
    }
  },
  {
    path: '/review/datamonitor/:test_id/:question_id/:question_index',
    name: 'Datamonitor | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/HSBC/DataMonitor.vue')
    }
  },
  {
    path: '/review/cappcritical/:test_id/:question_id/:question_index',
    name: 'Cappcritical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Deloitte/CappCritical.vue')
    }
  },
  {
    path: '/review/deloittesim/:test_id/:question_id/:question_index',
    name: 'Deloitte-sim | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Deloitte/DeloitteSim.vue')
    }
  },
  {
    path: '/review/clxtest/:test_id/:question_id/:question_index',
    name: 'Clxtest | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Cut-E/CLXTest.vue')
    }
  },
  {
    path: '/review/cutescales/:test_id/:question_id/:question_index',
    name: 'Cutescales | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Cut-E/CutEScales.vue')
    }
  },
  {
    path: '/review/memorytest/:test_id/:question_id/:question_index',
    name: 'Memorytest | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/CreditAgricolé/MemoryTest.vue')
    }
  },
  {
    path: '/review/sentenceoddoneout/:test_id/:question_id/:question_index',
    name: 'Sentenceoddoneout | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/CreditAgricolé/WordOddOneOut.vue')
    }
  },
  {
    path: '/review/lazardspatial/:test_id/:question_id/:question_index',
    name: 'Lazardspatial | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/CCAT/LazardSpatial.vue')
    }
  },
  {
    path: '/review/lazardlogical/:test_id/:question_id/:question_index',
    name: 'Lazardlogic | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/CCAT/LazardLogical.vue')
    }
  },
  {
    path: '/review/ccatlazard/:test_id/:question_id/:question_index',
    name: 'Ccatlazard | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/CCAT/CCATLazard.vue')
    }
  },
  {
    path: '/review/cappnumerical/:test_id/:question_id/:question_index',
    name: 'Cappnumerical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Cappfinity/CappNumerical.vue')
    }
  },
  {
    path: '/review/barclayscognitive/:test_id/:question_id/:question_index',
    name: 'Barclayscognitive | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Barclays/BarclaysCognitive.vue')
    }
  },
  {
    path: '/review/gapchallenge/:test_id/:question_id/:question_index',
    name: 'Gapchallenge | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Aon/GapChallenge.vue')
    }
  },
  {
    path: '/review/scalesix/:test_id/:question_id/:question_index',
    name: 'Scalesix | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Aon/ScalesIx.vue')
    }
  },
  {
    path: '/review/scalessx/:test_id/:question_id/:question_index',
    name: 'Scalessx | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Aon/ScalexSX.vue')
    }
  },
  {
    path: '/review/shlgeneralability/:test_id/:question_id/:question_index',
    name: 'Shlgeneralability | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLGeneralAbility.vue')
    }
  },
  {
    path: '/review/shlgeneralnumerical/:test_id/:question_id/:question_index',
    name: 'Shlgeneralnumerical | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/SHL/SHLGeneralNumerical.vue')
    }
  },
  {
    path: '/review/eysim/:test_id/:question_id/:question_index',
    name: 'Eysim | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Big4/EySim.vue')
    }
  },
  {
    path: '/review/kpmgsim/:test_id/:question_id/:question_index',
    name: 'Kpmgsim | Review',
    component: () => import('../components/results/TestReviewShell.vue'),
    props: { 
      component: () => import('../components/tests/Big4/KPMGSim.vue')
    }
  },

  {
    path: '/mobile',
    name: "We're building | doored",
    component: () => import('../views/MobileView.vue'),
  },
  {
    path: '/:pathName(.*)',
    name: 'Login || doored',
    component: () => import('../views/LoginView.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: function (to: RouteLocationNormalizedLoaded) {
    if (to.meta.scrollToTop) window.scrollTo(0, 0);
  }
})

router.beforeEach(async (to: RouteLocationNormalizedLoaded, from, next) => {
  document.title = to.name ? to.name as string : 'doored | the #1 site for assessment prep';
  const userStore = useUserStore()

  if (typeof window != undefined && window.matchMedia("(max-width: 1024px)").matches && to.meta.requiresAuth) {
    console.log("N/A on Mobile")
    next({path: '/mobile'})
    return;
  }

  if (!userStore.isSessionValidated) {
    await userStore.validateSession(true)
  }

  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    next({path: '/login'})
  } else {
    next()
  }
})

router.afterEach(async (to: RouteLocationNormalizedLoaded) => {
  if (to.path === '/') {
    const statsStore = useCompanyStatsStore()
    try {
      await statsStore.fetchStats(true)
    } catch (error) {
      console.error('Failed to refresh stats:', error)
    }
  }
})

export default router